import React, {Fragment, useState} from 'react';
import SvgIcon from "../../../common/SvgIcon";
import {truncateStrMiddle} from "./Utils";
import BookingReassignDesigner from "./BookingReassignDesigner";
import Textarea from '../../../common/components/Textarea';
import cn from "classnames";

const BookingPopup = ({ booking: initBooking, calendar, onUpdate, onSpam, onDelete, onCloseModal, admin }) => {
  const [booking, setBooking] = useState(initBooking);
  const startTime = new Date(booking.time_from);
  const time = startTime.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
  const date = startTime.toLocaleDateString("en-US", { month: 'long' ,day: '2-digit' , weekday: 'short' });
  const { documents, reassigned_designer: reassignedToDesigner } = booking;
  const onBookingSave = () => {
    onUpdate(booking);
    onCloseModal();
  };

  const onBookingSpam = () => {
    const confirmation = confirm(`
      SPAM ???
      
      ${time} ${date}
      ${booking.first_name} ${booking.last_name}
      ${booking.email}
      ${booking.phone}
    `);
    if (confirmation) {
      onSpam(booking);
    }
    onCloseModal();
  };

  const onDesignerChange = newDesigner => {
    const newBooking = { ...booking, reassigned_designer: newDesigner };
    setBooking(newBooking);
  };

  const onSalesNotesChange = salesNotes => {
    setBooking({ ...booking, sales_notes: salesNotes });
  };

  const spam = booking.status === 'spam';

  return (
    <Fragment>
      <div className="popupBackShadow" onClick={onCloseModal} />
      <div className={cn('bookingPopup', { '-spam': spam } )}>
        <div className="moodboard-modal_close" onClick={onCloseModal} />
        {spam && <h2>SPAM</h2>}
        <h3>{time} {date} <br/> {booking.first_name} {booking.last_name}</h3>
        <div>
          <h4>Customer:</h4>
          <a href={`mailto:${booking.email}`}>{`${booking.email}`}</a>
          <br/>
          <a href={`tel:${booking.phone}`}>{booking.phone}</a>
        </div>
        <div>
          <h4>Video Call Details:</h4>
          <a href={booking.call_start_url}>{booking.call_start_url}</a>
        </div>
        {admin && (
          <div className={'bookingInfo'}>
            <h4>Designer:</h4>
            <div className={'bookingDesigner'}>
              <b>{booking.designer.full_name}</b>
              <br/>
              <span>{booking.designer.email}</span>
            </div>
            <h4>Reassign to designer:</h4>
            <div className='bookingDesigner'>
              <BookingReassignDesigner calendar={calendar} booking={booking} designer={reassignedToDesigner} onDesignerChange={onDesignerChange}/>
            </div>
          </div>
        )}
        {!admin && reassignedToDesigner && (
          <div>
            <h4>Reassigned to designer:</h4>
            <div className='bookingDesigner'>
              {`${reassignedToDesigner.full_name} <${reassignedToDesigner.email}>`}
            </div>
          </div>
        )}
        <div className={'bookingInfo'}>
          {/*<div className='bookingStatus'>{booking.status}</div>*/}
          <div className='callNotes'>
            {booking.note || 'Client did not provide notes'}
          </div>
          <div className='bookingDocuments'>
            {(documents || []).map(document => (
              <div key={document.id} className='bookingDocument'>
                <a target='_blank' href={document.url}>
                  <SvgIcon icon='icon-chat-mediaFiles'/>
                  {truncateStrMiddle(document.filename, 25)}
                </a>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h4>Notes from sales team</h4>
          <Textarea
            type="text"
            name="text"
            className="callNotes"
            placeholder="text"
            value={booking.sales_notes}
            onChange={event => onSalesNotesChange(event.target.value)}
          />
        </div>

        <div className={'popupActions'}>
          {admin && (
            <Fragment>
              {!spam && (
                <button onClick={onBookingSpam} className="btn -red" style={{float: 'left'}}>SPAM</button>
              )}
              <button onClick={onBookingSave} className="btn -empty -y2023">Save</button>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default BookingPopup;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/BookingPopup.js